/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container-wide{max-width:1640px;margin-left:auto;margin-right:auto;padding-left:20px;padding-right:20px}@media (min-width:1024px){.container-wide{padding-left:30px;padding-right:30px}}.map-panel .rte{padding-left:20px;padding-right:20px}@media (min-width:1440px){.map-panel .rte{max-width:1440px;margin-left:auto;margin-right:auto;padding-left:30px;padding-right:30px}}.map-panel__description{margin-bottom:30px}"];
export { styles as styles };
